export enum OPENING_TYPE {
  black = 'black',
  light = 'light',
}

export interface Opening {
  openingType: OPENING_TYPE;
}
